import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorage } from "src/app/services/local-storage";
import { SessionService } from "src/app/services/session.service";
import { toastrService } from "src/app/services/ux/toastr.service";

@Component({
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.css"]
})
export class RegisterComponent implements OnInit {
  registerType: number = 0 // 0 - not set, 1 - personal, 2 - business

  constructor(
    public toastr: toastrService,
    private session: SessionService,
    private router: Router,
    public localStorage: LocalStorage,
  ) {

  }
  ngOnInit() {
    this.checkLogin()
  }

  checkLogin() {
    if (!!this.session.isLoggedIn()) this.router.navigateByUrl("/")
  }

  setRegisterType(type: number) {
    if (this.registerType === type) return
    this.registerType = type
  }

  resetRegisterType() {
    this.registerType = 0
  }

}
